module.exports = __webpack_public_path__ + "media/application/images/icons/pdf-9b2296ddc0cb254590d694562ae7bcb8.svg";